import {
  ProductVariant,
  StoreId,
  ProductInfo,
  UserSlerp
} from '@slerp/controls'
import { Store } from 'antd/lib/form/interface'
import { uuid } from 'uuidv4'

interface variantsProps {
  productVariants: Array<ProductVariant>
  storeId: Array<StoreId>
  values: Store
  product: ProductInfo
  user: UserSlerp
}

export const variants = (props: variantsProps) => {
  const { productVariants, storeId, values, product, user } = props

  let insertValues: {
    id: String
    name: String
    description: string | null
    product_id: String
    merchant_id: String
    sku: string | null
    default_variant: Boolean
    image: string | null
    price: Number
    vat: Number
    width: Number
    weight: Number
    height: Number
    length: Number
    limit: Number
    quantity: Number
    restrictions: {}
    options: any
    inserted_at: String
    updated_at: String
  }[] = []
  const defaultVariant = productVariants.find(
    (variant: ProductVariant) => variant.default_variant === true
  )!

  let store_variants: {
    id: string
    store_id: string
    variant_id: string
    inserted_at: string
    updated_at: string
    published_at: string
    in_stock: boolean
  }[] = []

  if (productVariants.length > 1) {
    const recentVariants = productVariants.reduce(
      (
        acc: { length: number; data: Array<ProductVariant> },
        cur: ProductVariant
      ) => {
        const { length, data } = acc
        if (!cur.options) {
          return acc
        }
        if (cur.options.length > length) {
          return {
            length: cur.options.length,
            data: [cur]
          }
        } else if (cur.options.length === length) {
          return {
            ...acc,
            data: [...data, cur]
          }
        }
        return acc
      },
      {
        length: 0,
        data: []
      }
    ).data

    recentVariants.forEach((variantData: ProductVariant) => {
      values.options.forEach((data: String) => {
        const variantId = uuid()
        const name = variantData.options.reduce((acc: any, cur: any) => {
          let value = ''
          if (acc === null) {
            value = `${defaultVariant.name} (${cur.value})`
          } else {
            value = `${acc} (${cur.value})`
          }
          return value
        }, null)

        storeId.forEach((storeId: { id: string }) => {
          const insert = {
            id: uuid(),
            store_id: storeId.id,
            variant_id: variantId,
            inserted_at: 'now()',
            updated_at: 'now()',
            published_at: 'now()',
            in_stock: true
          }
          store_variants.push(insert)
        })

        const variant = {
          id: variantId,
          name: `${name} (${data})`,
          description: null,
          product_id: product.id,
          merchant_id: user.merchant.id,
          sku: null,
          default_variant: false,
          image: null,
          price: 0,
          vat: 0,
          width: 0,
          weight: 0,
          height: 0,
          length: 0,
          limit: 0,
          quantity: 10,
          restrictions: {
            id: variantData.restrictions.id,
            alcoholic: variantData.restrictions.alcoholic
          },
          options: [
            ...variantData.options,
            {
              name: values.name,
              value: data
            }
          ],
          inserted_at: 'now()',
          updated_at: 'now()'
        }
        insertValues.push(variant)
      })
    })
  } else {
    values.options.forEach((data: String) => {
      const variantId = uuid()

      storeId.forEach((store: { id: string }) => {
        const insert = {
          id: uuid(),
          store_id: store.id,
          variant_id: variantId,
          inserted_at: 'now()',
          updated_at: 'now()',
          published_at: 'now()',
          in_stock: true
        }
        store_variants.push(insert)
      })

      const variant = {
        id: variantId,
        name: `${productVariants[0].name} (${data})`,
        description: null,
        product_id: product.id,
        merchant_id: user.merchant.id,
        sku: null,
        default_variant: false,
        image: null,
        price: 0,
        vat: 0,
        width: 0,
        weight: 0,
        height: 0,
        length: 0,
        limit: 0,
        quantity: 10,
        restrictions: {
          id: productVariants[0].restrictions.id,
          alcoholic: productVariants[0].restrictions.alcoholic
        },
        options: [
          {
            name: values.name,
            value: data
          }
        ],
        inserted_at: 'now()',
        updated_at: 'now()'
      }
      insertValues.push(variant)
    })
  }

  return { insertValues, store_variants }
}
